import {IScope} from "angular";
import {bindCallback, MonoTypeOperatorFunction, takeUntil} from "rxjs";
import {operate} from "rxjs/internal/util/lift";
import {createOperatorSubscriber} from "rxjs/internal/operators/OperatorSubscriber";
import {erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {map, tap} from "rxjs/operators";

const debug = initDebugger('rxjsHjelpere');

export function takeUntilAjs$destroy<T>($scope: IScope): MonoTypeOperatorFunction<T> {
    const destroySomObserverbar = bindCallback($scope.$on).call($scope, '$destroy')
    return takeUntil(destroySomObserverbar.pipe(tap(e => {
        debug('$destroy event fanget opp på $scope, avbryter observable', $scope);
    })));
}

/** Pipe operasjon som omslutter leveranse til subscriber i $scope.$applyAsync for bruk i Ajs-kontekst.
 * Sikrer med dette at eventuelle endringer i scope trigget av at subscriber leverer (til next, complete, error) fanges opp i Ajs */
export function omsluttLeveringIAjsApplyAsync<T>($scope: IScope): MonoTypeOperatorFunction<T> {
    function omsluttMedApplyAsync(lever: ()=>void){
        $scope.$applyAsync(() => {
            debug('kalt med $scope.$applyAsync, start')
            lever();
            debug('kalt med $scope.$applyAsync, slutt')
        });
    }
    return operate((source, subscriber) => {
        source.subscribe(
          createOperatorSubscriber(
            subscriber,
            //onNext
            //(value: T) => $scope.$applyAsync(() => subscriber.next(value)),
            (value: T) => omsluttMedApplyAsync(() => subscriber.next(value)),
            //onComplete
            () => omsluttMedApplyAsync(() => subscriber.complete()),
            //onError
            (error: any) => omsluttMedApplyAsync(() => subscriber.error(error)),
            //onFinalize - her trenger vi ikke å gjøre noe
          )
        );
    });
}

/** Utelater første leveranse dersom første leverte verdi er nil.
 * Brukes feks ifbm elf-basert lokalt datalager der vi ikke ønsker å få levert nil-verdi fordi datalageret er tomt
 * og Rest-kallet enda ikke har returnert, men ønsker å få levert senere nil-verdier som følge av at entitet har blitt
 * slettet (når entitet slettes i datalager trigger dette levering av 'undefined' til abonnenter). */
export function utelatFørsteDersomNil<T>(): MonoTypeOperatorFunction<T> {
    return operate((source, subscriber) => {
        let erFørsteLeveranse = true;
        source.subscribe(
          createOperatorSubscriber(subscriber, (value) => {
              if (erFørsteLeveranse && erNil(value)) {
                  erFørsteLeveranse = false;
                  return;
              }
              erFørsteLeveranse = false;
              subscriber.next(value)
          })
        );
    });
}

/** Sorterer samlinger levert av observable vhja angitt sorteringsfunksjon  */
export function sorterLevertSamling<T>(sorteringsfunksjon: (a:T, b:T)=>number): MonoTypeOperatorFunction<T[]> {
    return map(samling => samling.sort(sorteringsfunksjon));
}
